import ApexJiraProvider from "../core/providers/apex/ApexJiraProvider";
import ProviderFactory from "../core/ProviderFactory";
import {
  ApexProviderType,
  ProviderConfiguration,
} from "../core/types/Provider";

export default abstract class JiraIntegrationModel {
  private static provider: ApexJiraProvider = ProviderFactory.create(
    ApexProviderType.Jira,
    ProviderConfiguration.apex
  );
  private static categoryJira: Response = null;

  public static getCategoryJira(categoryId: number): Promise<Response> {
    return new Promise((resolve, reject) => {
      if (JiraIntegrationModel.categoryJira === null) {
        JiraIntegrationModel.provider
          .getCategoryJira(categoryId)
          .then((categoryJiraRes) => {
            JiraIntegrationModel.categoryJira = categoryJiraRes;
            resolve(categoryJiraRes);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        resolve(JiraIntegrationModel.categoryJira);
      }
    });
  }

  public static getDiscussionEpic(discussionId: number): Promise<Response> {
    return new Promise((resolve, reject) => {
      JiraIntegrationModel.provider
        .getDiscussionEpic(discussionId)
        .then((discussionEpicRes) => {
          resolve(discussionEpicRes);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
